module.exports = __webpack_public_path__ + "static/media/Cats eyes 07_FRANSKA-mixdown.36cfbffa.mp3";